import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-secondary-200" role="contentinfo">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-compass-3-line text-lg text-white"></i>
              </div>
              <span className="font-heading font-semibold text-lg text-white">海角导航</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-400">
              海角社区地址导航平台，为您提供最新官方入口、镜像备用链接及访问教程，助您随时随地畅游海角社区。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-secondary-400 hover:text-white transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-white transition-colors">关于我们</Link></li>
              <li><a href="#" className="text-sm text-secondary-400 hover:text-white transition-colors" rel="nofollow">站点地图</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">内容分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-400 hover:text-white transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">免责声明</h4>
            <p className="text-sm leading-relaxed text-secondary-400">
              本站仅提供海角社区地址导航信息整理，不存储任何社区内容。所有地址信息仅供学习参考，请遵守相关法律法规。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-secondary-500">
            &copy; {currentYear} 海角导航 —— 海角社区地址官方入口与访问指南
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-secondary-500 hover:text-white transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-secondary-500 hover:text-white transition-colors" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}